<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400"
      @click:outside="$emit('close')"
      persistent
    >
      <v-card>
        <v-card-title>Link to an item </v-card-title>
        <v-card-subtitle>Search for an item to link to</v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
          <autocomplete-all-2
            action="object"
            @selected="selected($event)"
            :giveFocus="open"
            :externalText="externalText"
          ></autocomplete-all-2>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-btn text @click="$emit('close')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import AutocompleteAll2 from "@/components/headerStuff/AutocompleteAll-2";

// ! todo - merge this component with other autocomplete dialog component

export default {
  name: "GetLinkDialog",
  components: { AutocompleteAll2 },
  props: {
    // onlyModule: { type: String, default: null },
    open: null,
    externalText: null,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {
    selected(obj) {
      // console.log(obj);

      let rtn = {};
      // todo - do some error checking

      //   let mod = this.onlyModule;
      if (obj.module == "MED") {
        rtn.name = obj.name;
        rtn.url = "/meds/details/" + obj.slug;
      } else {
        rtn.name = obj.name;
        rtn.url = obj.url;
      }
      this.$emit("link", rtn);
      this.$emit("close", false);
    },
  },
  computed: {},
  watch: {
    open(val) {
      this.dialog = val;
    },
  },
};
</script>

<style scoped></style>
